import { sanitizeRequestBody } from '@atlas/api-client'

/**
 * Strip live native Firestore refs / cyclical structures from a request body so serialization
 * can't crash on iOS (legacy `apiClient.js` axios instance).
 *
 * Single source of truth lives in `@atlas/api-client` (ATL-523) — the typed/dual-write client
 * uses the same sanitizer in its `serializeDates`. Here we pass `serializeDates: false` because
 * the legacy axios instance serializes Date objects itself, so we preserve them.
 *
 * @param {unknown} data axios request body
 * @returns {unknown} a sanitized copy (opaque body types pass through unchanged)
 */
export function sanitizeRequestData(data) {
  return sanitizeRequestBody(data, { serializeDates: false })
}
